const Hash = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.49773 3.01352C10.0425 3.10431 10.4105 3.61954 10.3197 4.16431L9.84713 6.99991H15.8195L16.3469 3.83551C16.4377 3.29074 16.953 2.92272 17.4977 3.01352C18.0425 3.10431 18.4105 3.61954 18.3197 4.16431L17.8471 6.99991H20C20.5523 6.99991 21 7.44763 21 7.99991C21 8.5522 20.5523 8.99991 20 8.99991H17.5138L16.5138 14.9999H20C20.5523 14.9999 21 15.4476 21 15.9999C21 16.5522 20.5523 16.9999 20 16.9999H16.1805L15.6531 20.1643C15.5623 20.7091 15.047 21.0771 14.5023 20.9863C13.9575 20.8955 13.5895 20.3803 13.6803 19.8355L14.1529 16.9999H8.18046L7.65306 20.1643C7.56226 20.7091 7.04704 21.0771 6.50227 20.9863C5.9575 20.8955 5.58948 20.3803 5.68027 19.8355L6.15287 16.9999H4C3.44772 16.9999 3 16.5522 3 15.9999C3 15.4476 3.44772 14.9999 4 14.9999H6.48621L7.48621 8.99991H4C3.44772 8.99991 3 8.5522 3 7.99991C3 7.44763 3.44772 6.99991 4 6.99991H7.81954L8.34694 3.83551C8.43773 3.29074 8.95296 2.92272 9.49773 3.01352ZM9.51379 8.99991L8.51379 14.9999H14.4862L15.4862 8.99991H9.51379Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Hash;
